import React, { FC } from 'react';

import { CheckOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { ExperienceDetailStatusEnum } from 'src/shared/enums';
import { IExperienceDetailWrapper } from 'src/shared/models';

export enum ButtonStatusEnum {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  SOON = 'soon',
  DONE = 'done',
}

export interface IButton {
  label?: string;
  status: ButtonStatusEnum;
  performAction?: () => void;
}

export const ExperienceDetailWrapper: FC<IExperienceDetailWrapper> = ({
  children,
  title,
  status,
  points,
  label,
  button,
}) => {
  const { formatMessage } = useIntl();
  const { DISABLED, HIDDEN, IN_PROGRESS, DONE } = ExperienceDetailStatusEnum;
  const wrapperStatus = status ?? DISABLED;

  const statusIconState: string = classnames(
    'icon icon__size-85 icon--process-check',
    {
      'icon--process-check-disabled':
        wrapperStatus === DISABLED || wrapperStatus === HIDDEN,
    },
    {
      'icon--process-check-progress': wrapperStatus === IN_PROGRESS,
    }
  );

  const wrapperLabel = label && (
    <div className="experience-detail__label">
      <div className="experience-detail__label--content">{label}</div>
    </div>
  );

  const wrapperDisabled = status === DISABLED && (
    <div className="experience-detail__blocked">
      <div className="experience-detail__blocked--content">
        <span className="icon icon--experience-lock content__icon" />
        <p className="content__text">
          {formatMessage({ id: 'experience.blocked' })}
        </p>
      </div>
    </div>
  );

  //TODO: Design Missing!
  const wrapperHidden = status === HIDDEN && (
    <div className="experience-detail__blocked">
      <div className="experience-detail__blocked--content">
        <span className="icon icon--experience-lock content__icon" />
        <p className="content__text wrapperHidden">
          {formatMessage({ id: 'page.experience.end-date' })}
        </p>
      </div>
    </div>
  );

  const pointsClassName = classnames('experience-detail__points', {
    'experience-detail__points--blocked': wrapperStatus === DISABLED,
  });

  const wrapperPoints = points > 0 && (
    <div className={pointsClassName}>
      {formatMessage(
        { id: 'experience.detail-points' },
        { points: Math.abs(Number(points)) }
      )}
    </div>
  );

  const handleClick = () => {
    if (!button.performAction) return;
    button.performAction();
  };

  const wrapperButton = button?.label && status !== DISABLED && (
    <div
      className={`experience-detail__button experience-detail__button--${button.status}`}
      onClick={handleClick}
    >
      <div
        className={`experience-detail__button--content experience-detail__button--content-${button.status}`}
      >
        {button.label}
      </div>
    </div>
  );

  return (
    <div
      className={`experience-detail-container experience-detail-container-status-${wrapperStatus}`}
    >
      <div
        className={`experience-detail ${
          status === DISABLED ? 'experience-detail-row' : ''
        }`}
      >
        <div className="experience-detail__title">
          <div className="experience-detail__title--content">{title}</div>
        </div>
        {wrapperLabel}
        {children}
        {wrapperPoints}
        {wrapperDisabled}
        {wrapperHidden}
        {wrapperButton}
      </div>
    </div>
  );
};
